<template>
  <div class="avatar-outer" v-if="user">
    <div class="avatar" v-if="user.logo" v-bind:style="{ backgroundImage: 'url(' + user.logo + ')' }">
    </div>
    <div class="avatar evity-orange-background-color" v-else >
      <div v-if="user" class="initials">{{ user.first_name[0] }}{{ user.last_name[0]}}</div>
    </div>
    <div class="container avatar-container">
      <div class="container is-size-7" v-if="user">
        {{ user.first_name }}
      </div>
    </div>
  </div>



</template>
<script>

export default {
  name: 'UserAvatar',
  props: ['user', ],
  data() {
    return {
    }
  },

}

</script>
<style lang="scss" scoped>
.avatar-outer {
  width: 45px;
  height: 55px;
  //display: flex;

}

.avatar {
  background-position: center center;
  background-size: cover;
  border-radius: 20px;
  border: 1px solid black;
  text-align: center;
  font-weight: bold;
  width: 40px;
  height: 40px;
  margin: auto;
  //position: relative;
}

.initials {
  margin: 0;
  //position: absolute;
  //top: 50%;
  //left: 50%;
  //transform: translate(-50%, -50%);
  transform: translateY(7px);
}

.avatar-container {
  height:10px;
}

</style>